import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import DealerReviewTable from "../../../Components/Table/DealerReviewTable";

const realization_percentage_list_api = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-review/realization_percentage_list",
      body
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching offtake data:", error);
    throw error;
  }
};

const Volume_Performance_Realization = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const {
    data: realization_Data,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["realization", submitted],
    queryFn: () => realization_percentage_list_api(data),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );

  if (isError) return <div>Error loading data.</div>;

  if (!realization_Data || realization_Data.length === 0)
    return <div className="text-center text-gray-500">Data Not Available</div>;

  return (
    <DealerReviewTable
      name={"Realization as % of list price"}
      data={realization_Data}
    />
  );
};

export default Volume_Performance_Realization;
